(function ($) {
  init();
  function init() {
    __headerNaviAddClass();
  }
  
  // ヘッダーナビのBrandsにクラス付与
  function __headerNaviAddClass() {
    const interval = setInterval(() => {
      const $brandMenuItems = $(
        '.header__nav .menu__panel > .menu__item:contains("Brands")'
      );
      if ($brandMenuItems.length > 0) {
        clearInterval(interval);
        $brandMenuItems.addClass("header__nav__item-brand");
      }
    }, 100);
  }
})(jQuery);
